const SectionNames = {
  Text: 'text',
  Amount: 'amount',
  Link: 'link',
  Transactions: 'transactions',
  TransactionTable: 'transactionTable',
  LineBreak: 'lineBreak',
  BarGraph: 'barGraph',
};

export default {
  SectionNames,
};
